import { colors, Typography } from '@ui-components/neo.tax';
import React, { ReactElement } from 'react';

import { VirtualizedList } from '../virtualized-list';
import { MemoizedTicketRow, TicketRowTicketType } from './TicketRow';
import { EmptyStateInner, EmptyStateOuter } from './tickets-list.styled';

type TicketsListProps = {
  tickets: TicketRowTicketType[];
  selectedIds: Set<string>;
  setSelectedIds: React.Dispatch<React.SetStateAction<Set<string>>>;
  loadMore?: () => void | PromiseLike<void>;
  isLoading: boolean;
  Footer?: () => ReactElement;
  loadMoreRowFromBottomThreshold?: number;
  isGroupingSelected?: boolean;
  disableSelection?: boolean;
};

export const TicketsList = ({
  Footer,
  disableSelection = false,
  isGroupingSelected = false,
  isLoading,
  loadMore,
  loadMoreRowFromBottomThreshold = 10,
  selectedIds,
  setSelectedIds,
  tickets,
}: TicketsListProps): ReactElement =>
  tickets.length === 0 && !isLoading ? (
    <EmptyStateOuter direction="column" justifyContent="center">
      <EmptyStateInner direction="column" justifyContent="center">
        <Typography color={colors.gray[300]} fontSize="sm" fontWeight="semibold" textAlign="center">
          No matching tickets
        </Typography>
      </EmptyStateInner>
    </EmptyStateOuter>
  ) : (
    <VirtualizedList
      data={tickets ?? []}
      isLoading={isLoading}
      loadMore={loadMore}
      height={(tickets?.length ?? 0) * 48 + 32} // 48px per item + 32px for footer
      MemoizedRowComponent={({ item }) => (
        <MemoizedTicketRow
          key={item.id}
          item={{
            ...item,
            selected: selectedIds.has(item.id),
            onSelectedChange: disableSelection
              ? undefined
              : (selected: boolean): void => {
                  setSelectedIds((selectedIds) => {
                    const newSelectedIds = new Set(selectedIds);
                    if (selected) {
                      newSelectedIds.add(item.id);
                    } else {
                      newSelectedIds.delete(item.id);
                    }
                    return newSelectedIds;
                  });
                },
            disabled: disableSelection,
            isGroupingSelected,
          }}
        />
      )}
      Footer={Footer}
      loadMoreRowFromBottomThreshold={loadMoreRowFromBottomThreshold}
    />
  );
